import { render, staticRenderFns } from "./PriceInfo.vue?vue&type=template&id=3ab95f3e&scoped=true"
import script from "./PriceInfo.vue?vue&type=script&lang=js"
export * from "./PriceInfo.vue?vue&type=script&lang=js"
import style0 from "./PriceInfo.vue?vue&type=style&index=0&id=3ab95f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab95f3e",
  null
  
)

export default component.exports